import { useEffect } from 'react';
import { checkAuthorization } from '~/rtk-store/auth';
import { useAppDispatch } from './redux';

export default function useCheckAuthorization() {
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(checkAuthorization());
    }, [dispatch]);
}
